require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-chelsea-data-entry-full-stack.json") })
        }
      }, "path---blog-meet-chelsea-data-entry-full-stack");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-chelsea-data-entry-full-stack!./.cache/json/blog-meet-chelsea-data-entry-full-stack.json
// module id = 939
// module chunks = 231608221292675